module.exports = __webpack_public_path__ + "static/media/lv_ru_desk_s.7172d8ba.png";